module.exports = __webpack_public_path__ + "static/img/command-home-img.bc19a343.png";